import Lenis from "lenis";
import { useEffect, useRef } from "react";

let globalLenis: Lenis | null = null;

export function useSmoothScroll() {
  const lenisRef = useRef<Lenis | null>(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      orientation: "vertical",
      gestureOrientation: "vertical",
      smoothWheel: true,
      wheelMultiplier: 0.8,
      touchMultiplier: 1.5,
      infinite: false,
    });

    lenisRef.current = lenis;
    globalLenis = lenis;

    function raf(time: number) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
      globalLenis = null;
    };
  }, []);

  return lenisRef.current;
}

export function scrollToTop() {
  if (typeof window === "undefined") return;
  if (globalLenis) {
    globalLenis.scrollTo(0, {
      duration: 1.2,
      immediate: false,
    });
  } else {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }
}

export function scrollToSection(sectionId: string) {
  if (typeof window === "undefined") return;
  if (globalLenis) {
    globalLenis.scrollTo(`#${sectionId}`, {
      duration: 1.2,
      immediate: false,
    });
  } else {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }
}
